<img lazy-image="" [src]="user?.avatar || 'assets/images/contacts/avatar-placeholder.png'" [attr.alt]="user?.name"/>
